// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"77efc304","375":"3424cb8e","695":"54989c8c","800":"d56deef8"}[chunkId] + ".chunk.js";
};